import React from 'react';
import Head from 'next/head';

import AuthLayout from '@src/layouts/Auth';
import SignInTemplate from '@src/templates/SignIn';

const SignInPage = () => {
  return (
    <>
      <Head>
        <title>Sign In - Riiid for Classrooms</title>
      </Head>

      <SignInTemplate />
    </>
  );
};

SignInPage.layout = AuthLayout;

export default SignInPage;
